import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';

const MailSendDialog = ({ open, preview, sending, onCancel, onConfirm }) => {
  const renvoi = preview?.kind === 'renvoi';
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next && !sending) onCancel(); }}>
      <DialogContent className="bg-card border border-border max-h-[85vh] overflow-y-auto" data-testid="mail-confirm-dialog">
        <DialogHeader>
          <DialogTitle>
            {renvoi ? 'Renvoyer ce rapport par e-mail ?' : 'Envoyer ce rapport par e-mail ?'}
          </DialogTitle>
          <DialogDescription>
            Rien n'est envoyé avant confirmation. Le PDF du rapport est joint au message.
          </DialogDescription>
        </DialogHeader>
        {preview ? (
          <div className="space-y-3 text-sm">
            <div>
              <p className="text-xs uppercase text-muted-foreground mb-1">Destinataires</p>
              <p data-testid="mail-confirm-recipients">{(preview.recipients || []).join(', ') || '—'}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-muted-foreground mb-1">Objet</p>
              <p data-testid="mail-confirm-subject">{preview.subject}</p>
            </div>
            <div>
              <p className="text-xs uppercase text-muted-foreground mb-1">Message</p>
              <pre className="whitespace-pre-wrap font-sans text-sm bg-zinc-900/50 border border-border rounded-md p-3 max-h-28 overflow-y-auto" data-testid="mail-confirm-message">{preview.message}</pre>
            </div>
            <div>
              <p className="text-xs uppercase text-muted-foreground mb-1">Pièce jointe</p>
              <p data-testid="mail-confirm-attachment">{preview.attachment || 'PDF du rapport'}</p>
            </div>
          </div>
        ) : null}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={sending}
            data-testid="btn-mail-cancel"
            className="flex-1 h-11 px-4 rounded-md bg-secondary text-secondary-foreground font-medium"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={sending || !preview}
            data-testid="btn-mail-confirm"
            className="flex-1 h-11 px-4 rounded-md bg-primary text-primary-foreground font-semibold"
          >
            {sending ? 'Envoi…' : (renvoi ? 'Renvoyer' : 'Envoyer')}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MailSendDialog;
